import styled from "styled-components";

export const Item = styled.div`
    margin-left: 10px;
    color: #4f4f4f;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px;
    width: 100%;
    font-size: 12px !important;
    cursor: pointer;
    `